export const data1: string[] = ['Plan amplio', 'Plan limitado', 'Plan básico'];
export const data2: string[] = [
  'Las opciones más económicas',
  'Las opciones más costosas',
  'Todas las opciones',
];
